import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import CaseCard from "@/components/feature/CaseCard";
import VerdictBadge from "@/components/base/VerdictBadge";
import { cases } from "@/mocks/cases";

export default function ReversalTracker() {
  const [lead, ...rest] = cases;
  const trackers = rest.slice(0, 3);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Reversal Tracker"
          title="最新反转追踪"
          desc="从最初的爆料到最终核验，每一起事件都按时间顺序记录关键节点。点开任意案例，可以看到完整的时间线与官方回应。"
          action={
            <Link
              to="/cases"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              全部案例
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <CaseCard item={lead} variant="featured" />
          </div>

          <div className="lg:col-span-5">
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center justify-between border-b border-background-300 pb-3">
                <h3 className="font-heading text-base font-bold text-foreground-950">追踪中</h3>
                <span className="flex items-center gap-1.5 text-xs text-primary-600">
                  <span className="h-2 w-2 rounded-full bg-primary-500 animate-pulse-dot" aria-hidden="true" />
                  实时更新
                </span>
              </div>

              <ul className="mt-2 flex flex-1 flex-col divide-y divide-background-200">
                {trackers.map((item) => {
                  const latest = item.timeline[item.timeline.length - 1];
                  return (
                    <li key={item.id} className="py-4">
                      <Link to={`/cases/${item.slug}`} className="group block">
                        <div className="flex items-center justify-between gap-3">
                          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                            <i className="ri-time-line text-sm" aria-hidden="true" />
                            {latest.date}
                          </span>
                          <VerdictBadge verdict={item.status} />
                        </div>
                        <h4 className="mt-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                          {item.title}
                        </h4>
                        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                          {latest.title}：{latest.desc}
                        </p>
                      </Link>
                    </li>
                  );
                })}
              </ul>

              <Link
                to="/cases"
                className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                查看全部追踪
                <i className="ri-arrow-right-line text-base" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}